
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/forgot",
      function () {
        return require("private-next-pages/profile/forgot/index.js");
      }
    ]);
  